/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Pending_RegenerateInputs */

const vi_einvoice_pending_regenerate = /** @type {(inputs: Einvoice_Pending_RegenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo lại nháp`)
};

/**

* @param {Einvoice_Pending_RegenerateInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_pending_regenerate = /** @type {((inputs?: Einvoice_Pending_RegenerateInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Pending_RegenerateInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_pending_regenerate(inputs)
});